import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectDataTimestamps} from '../../../../../features/core/store/core.selectors';
import {Observable} from 'rxjs';
import {IDataTimeStamps} from '../../../../../features/core/models/data-time-stamps';
import {IStore} from '../../../../shared-models/store/store';
import {getDataTimeStamps} from '../../../../../features/core/store/core.actions';

@Component({
  selector: 'app-shared-freshness-indicator-container',
  templateUrl: './shared-freshness-indicator-container.component.html',
  styleUrls: ['./shared-freshness-indicator-container.component.scss'],
  standalone: false,
})
export class SharedFreshnessIndicatorContainerComponent implements OnInit {
  @Input() dataType = 'stock';
  @Input() currentStore: IStore;
  dataTimeStamps$: Observable<Record<string, IDataTimeStamps>>;

  constructor(
    private readonly store: Store,
  ) {
  }

  ngOnInit(): void {
    this.dataTimeStamps$ = this.store.select(selectDataTimestamps);
    this.store.dispatch(getDataTimeStamps());
  }

}
